export function scrollIntoView(
    element: HTMLElement,
    container?: HTMLElement,
    offset = 70
) {
    const scrollContainer = container || window
    let scrollPosition = element.offsetTop - offset

    if (!container) {
        const box = element.getBoundingClientRect()

        const body = document.body
        const docEl = document.documentElement

        const scrollTop =
            window.pageYOffset || docEl.scrollTop || body.scrollTop

        const clientTop = docEl.clientTop || body.clientTop || 0

        const top = box.top + scrollTop - clientTop

        scrollPosition = top - offset
    }

    if (scrollContainer.scrollTo) {
        scrollContainer.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: scrollPosition,
        })
    } else if ('scrollTop' in scrollContainer) {
        scrollContainer.scrollTop = scrollPosition
    }
}
